import { type FunctionComponent } from 'react';

import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

const CardPaymentFormError: FunctionComponent = () => (
  <div className="m-auto">
    <PleaseWaitOverlay
      icon="error"
      title="There was an error fetching your payment link"
      labelLine1="Please refresh the page to try again. If this error persists, please reach out to Kanda"
    />
  </div>
);

export default CardPaymentFormError;
